
































































import {
  Vue, Prop, Component, Emit,
} from 'vue-property-decorator';
import toCurrency from '@/shared/directive/toCurrency';
import DateFormat from '@/shared/utils/date-format';
import Headers from './calculations-table-headers.json';

@Component({
  filters: { toCurrency },
})
export default class BillingInfoContentCalculationsTable extends Vue {
  @Prop({
    required: true,
  })
  items!: any;

  headers: any = Headers;

  @Prop({
    required: true,
  })
  currency: any;

  currencyFormat: any = toCurrency;

  @Emit('openSystemLog')
  openSystemLog(createdDate: string, summary: string[]) {
    const logSummary = {
      createdDate,
      summary,
    }
    return logSummary;
  }

  competence(month: number, year: number): string {
    return DateFormat.fullMonthAndYear(`${month}/${year}`);
  }
}
